import { cn } from '@bem-react/classname';

export const cnTabsMenuItem = cn('TabsMenuItem');
